/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolStoreIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-store"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.88 3.25L19.13 3.25Q19.68 3.25 20.06 3.64Q20.45 4.03 20.45 4.58Q20.45 5.13 20.06 5.51Q19.68 5.9 19.13 5.9L4.88 5.9Q4.33 5.9 3.94 5.51Q3.55 5.13 3.55 4.58Q3.55 4.03 3.94 3.64Q4.33 3.25 4.88 3.25ZM4.88 20.75Q4.33 20.75 3.94 20.36Q3.55 19.98 3.55 19.43L3.55 14.65L3.52 14.65Q2.88 14.65 2.49 14.16Q2.1 13.68 2.23 13.05L3.33 7.95Q3.42 7.5 3.79 7.2Q4.15 6.9 4.63 6.9L19.38 6.9Q19.85 6.9 20.21 7.2Q20.57 7.5 20.68 7.95L21.77 13.05Q21.9 13.68 21.51 14.16Q21.13 14.65 20.48 14.65L20.45 14.65L20.45 19.43Q20.45 19.98 20.06 20.36Q19.68 20.75 19.13 20.75Q18.57 20.75 18.19 20.36Q17.8 19.98 17.8 19.43L17.8 14.65L14.35 14.65L14.35 19.43Q14.35 19.98 13.96 20.36Q13.57 20.75 13.03 20.75ZM6.2 18.1L11.7 18.1L11.7 14.65L6.2 14.65Z" fill={color} />
    </svg>
  );
}
